import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { ISPEDSecurityUser } from '../Models/ISPEDSecurityUser';
import { ISubstituteServiceProvider } from '../Models/ISubstituteServiceProvider';

@Injectable()
export class UserService extends BaseService {
  _baseUrl: string = "";

  constructor(
    protected _http: HttpClient,
    @Inject('BASE_URL') baseUrl: string
  ) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  userLoggedIn() {
    return this._http.get(this._baseUrl + 'api/Security/UserLoggedIn')
      .map((response: ISPEDSecurityUser) => response as ISPEDSecurityUser)
      .catch(this.errorHandler);
  }

  logOut() {
    return this._http.get(this._baseUrl + 'api/Account/LogOut')
  }

  getSubstituteServiceProviders(serviceProviderId: number): Observable<ISubstituteServiceProvider[]> {
    return this._http.get<ISubstituteServiceProvider[]>(this._baseUrl + 'api/Security/GetSubstituteServiceProviders' + serviceProviderId)
      .map((response: ISubstituteServiceProvider[]) => response as ISubstituteServiceProvider[])
      .catch(this.handleError);
  }

  startSubstituting(substituteServiceProviderId: number): Observable<ISubstituteServiceProvider> {
    return this._http.get<ISubstituteServiceProvider>(this._baseUrl + 'api/Security/StartSubstituting' + substituteServiceProviderId)
      .map((response: ISubstituteServiceProvider) => response as ISubstituteServiceProvider)
      .catch(this.errorHandler);
  }

  stopSubstituting() {
    return this._http.get(this._baseUrl + 'api/Security/StopSubstituting')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response): Observable<any> {
    console.log(error);
    return Observable.throw(error);
  }

}

